export default __webpack_public_path__ + "static/media/fermentation.402a21cb.jpg";